import { useMemo } from "react";
import { useSortContext } from "../contexts/SortProvider";
import { comparators } from "../utils/comparators";

export const useSortedProducts = (products = []) => {
	const { sortBy, comparators: customComparators } = useSortContext();

	const sortedProducts = useMemo(() => {
		const comparator =
			// eslint-disable-next-line no-unused-vars
			customComparators?.[sortBy] ?? comparators?.[sortBy] ?? ((_a, _b) => 0);

		return [...products].sort(comparator);
	}, [products, sortBy, customComparators]);

	return { sortedProducts, sortBy };
};
